export default __webpack_public_path__ + "static/media/cosmetic2.04093042.JPG";